import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const Page = forwardRef(
  ({ children, title = '', noindex = true, ...rest }, ref) => {
    return (
      <Box
        ref={ref}
        sx={{
          minHeight: '100%',
          paddingTop: 3,
          paddingBottom: 3,
        }}
        {...rest}
      >
        <Helmet>
          <title>{title}</title>
          {noindex && <meta name="robots" content="noindex" />}
        </Helmet>
        {children}
      </Box>
    );
  }
);

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Page;
